var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgForaging(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 1000 1000",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "foraging") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "transparent_squares",
    "data-name": "transparent squares"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.53,
    width: 1000,
    height: 1000,
    style: {
      fill: "none"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "outside"
  }, /*#__PURE__*/React.createElement("g", {
    id: "grass"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M593.62,341.2c-1.55,1.26-3.12,2.56-4.69,3.9q-4.95,4.17-10,8.77l-2.56,2.34s-.07.06-.1.1q-2.52,2.32-5.06,4.75l-.1.09c-1.7,1.62-3.4,3.26-5.11,5-.9.89-1.81,1.78-2.72,2.69L560,372.1c-1.64,1.66-3.28,3.36-4.93,5.08l-1.65,1.73-3.31,3.52s0,.07-.09.09q-5.4,5.79-10.86,12l-3.64,4.14-1.83,2.11c-2.12,2.47-4.27,5-6.41,7.52s-4.29,5.12-6.43,7.74c-.66.81-1.32,1.61-2,2.42l-2,2.45q-2,2.46-4,5l-4,5L505,436q-4.76,6.19-9.51,12.63l-.09.11c-2.26,3.05-4.51,6.15-6.77,9.27-.84,1.18-1.68,2.35-2.54,3.53q-8.86,12.45-17.7,25.62h85.85c25.5-58,41.68-110.82,46.92-151.77,0,0,0-.07,0-.11C598.71,337.13,596.17,339.13,593.62,341.2Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M601.32,335.14l-.12.2L513.54,487.11H468.45q8.81-13.17,17.68-25.62c.86-1.18,1.7-2.36,2.54-3.53q3.39-4.69,6.77-9.27l.09-.11q4.75-6.43,9.51-12.63l4-5.13,4-5c1.32-1.67,2.64-3.32,4-5,.67-.81,1.32-1.63,2-2.44l2-2.39h0q3.23-3.94,6.43-7.76c2.14-2.55,4.29-5.05,6.41-7.52l1.83-2.11,3.64-4.14q5.46-6.17,10.86-12s.06-.06.09-.09l3.31-3.52q.84-.87,1.65-1.74,2.49-2.58,4.93-5.07l3.27-3.3c.91-.91,1.82-1.8,2.72-2.69q2.57-2.52,5.11-5l.1-.09q2.53-2.43,5.06-4.75s.07-.06.1-.1l2.56-2.34q5.05-4.59,10-8.77c1.57-1.34,3.14-2.64,4.69-3.9Q597.52,338,601.32,335.14Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M541,255.23l-.25.27c-13.95,15.14-28.42,34.17-42.9,56.45-.74,1.13-1.48,2.28-2.22,3.44-10.67,16.65-21.33,35-31.79,54.9a1041,1041,0,0,0-52.17,116.82h89c7.81-24.37,14.53-48.19,20.12-71.1h0v0C536.16,353.25,543,297.29,541,255.23Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M540.88,255.2l-.11.3L456.91,487.11H412a1042.71,1042.71,0,0,1,51.81-116.56c10.47-20,21.14-38.43,31.82-55.16.74-1.16,1.48-2.31,2.22-3.44C512.38,289.54,526.88,270.4,540.88,255.2Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M459,168.15c-.06-.27-.12-.53-.17-.8s-.11-.46-.16-.69c-.12.18-.24.36-.35.55-21.93,34.25-43.17,83.36-61,141.92h0a1100.32,1100.32,0,0,0-30.64,129.15q-4.37,24.78-7.56,48.82h86.72q3.44-16.61,6.45-33.72c5-28.39,8.85-56.14,11.56-82.84l0-.26C472.09,289.35,470,218.06,459,168.15Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M458.44,166.66l-.1.55-.17.94-56.32,319H358.76q3.21-24,7.58-48.84a1098.32,1098.32,0,0,1,30.24-127.71h0c.22-.72.43-1.44.65-2.16,17.82-58.13,38.95-106.91,60.76-141C458.14,167.12,458.28,166.89,458.44,166.66Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,310.56h0l-.13-1.41h0c0-.25,0-.49-.07-.74-7-78.67-21.65-146.11-41-192.34C336.52,163,321.71,231.76,314.85,312h0c-2.76,32.17-4.23,66.19-4.23,101.36,0,25.29.76,50,2.22,73.79h86.72c1.46-23.82,2.22-48.5,2.22-73.79C401.78,377.63,400.26,343.14,397.43,310.56Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.43,310.56h0l-.13-1.41h0c0-.25,0-.49-.07-.74-7-78.67-21.65-146.11-41-192.34C336.52,163,321.71,231.76,314.85,312h0c-2.76,32.17-4.23,66.19-4.23,101.36,0,25.29.76,50,2.22,73.79h86.72c1.46-23.82,2.22-48.5,2.22-73.79C401.78,377.63,400.26,343.14,397.43,310.56Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M356.2,116.05V487.11H312.84c-1.46-23.82-2.22-48.5-2.22-73.79,0-35.17,1.47-69.19,4.23-101.36h0C321.71,231.76,336.52,163,356.2,116.05Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352.22,487.11H265.48q-3.41-16.53-6.43-33.6c-5-28.48-8.86-56.32-11.58-83.1-8.31-81.75-6.13-153.66,5.16-203.64C275,201.58,296.71,251.89,314.85,312h0a1104.58,1104.58,0,0,1,29.83,126.45Q349,463.13,352.22,487.11Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M309.12,487.11H265.48q-3.41-16.53-6.43-33.6c-5-28.48-8.86-56.32-11.58-83.1-8.31-81.75-6.13-153.66,5.16-203.64Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,487.11h-89c-7.8-24.33-14.51-48.1-20.09-71h0c-15.31-62.74-22.18-118.71-20.17-160.77,25,27.08,51.71,66.73,77.16,115.06A1040.51,1040.51,0,0,1,299.58,487.11Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M299.58,487.11h-89c-7.8-24.33-14.51-48.1-20.09-71h0c-15.31-62.74-22.18-118.71-20.17-160.77,25,27.08,51.71,66.73,77.16,115.06A1040.51,1040.51,0,0,1,299.58,487.11Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.66,487.11H210.57c-7.8-24.33-14.51-48.1-20.09-71h0c-15.31-62.74-22.18-118.71-20.17-160.77Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,487.11H157c-25.49-58-41.67-110.83-46.88-151.76,24.76,18.82,52.28,46.44,80.36,80.77h0C207.89,437.38,225.5,461.2,242.82,487.11Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.82,487.11H157c-25.49-58-41.67-110.83-46.88-151.76,24.76,18.82,52.28,46.44,80.36,80.77h0C207.89,437.38,225.5,461.2,242.82,487.11Z",
    style: {
      fill: "#bdf271"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M197.73,487.11H157c-25.49-58-41.67-110.83-46.88-151.76Z",
    style: {
      fill: "#00a388",
      fillOpacity: 0.28
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "poop"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M798.85,716.41a628.55,628.55,0,0,1-82.23,5.52A629.5,629.5,0,0,1,560.8,702.56a19.55,19.55,0,0,1-13.52-5.6,19.09,19.09,0,0,1-5.61-13.53V676.8a69.74,69.74,0,0,1,21-49.94c0,.42,0,.84,0,1.26C562.6,670.51,662.91,706.15,798.85,716.41Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M889.76,677.26v6.17a19.14,19.14,0,0,1-19.13,19.13,627.8,627.8,0,0,1-71.78,13.85c-135.94-10.26-236.25-45.9-236.25-88.29,0-.42,0-.84,0-1.26a69.87,69.87,0,0,1,49-20.05H819.31a70.08,70.08,0,0,1,22.27,3.6c-6.5,7.35-19.22,13.63-35,18.61a70,70,0,0,0,34.13-8.52c1.19-.63,2.35-1.31,3.48-2a69,69,0,0,0,6.32-4.4A70.44,70.44,0,0,1,889.76,677.26Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M758.11,639.28a333.7,333.7,0,0,1-40.81,2.9c-54.84.3-130.08-16-132.14-41.7-.74-9.13,7.8-19.39,22-28.79,17.51,32.91,75.74,59,150.21,67.52Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M846.27,600.48a17.07,17.07,0,0,1-4.69,9.93c-6.5,7.35-19.22,13.63-35,18.61a287.37,287.37,0,0,1-48.49,10.26l-.7-.07c-45.07-5.16-84.2-16.75-111.94-32.4-18.1-10.2-31.35-22.12-38.27-35.12A147.68,147.68,0,0,1,627,560.91a222,222,0,0,1,88.74-19.5l2.38,0a198.92,198.92,0,0,1,20.52,1.35,225.82,225.82,0,0,1,60.68,15.86c-6.06,5.39-16.22,9.67-28,12.9,1.52.1,3.07.15,4.62.15a70,70,0,0,0,33.45-8.44C832.27,574.58,847.24,588.51,846.27,600.48Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M725.35,579c-3.49.24-6.83.4-10,.49-24.53.68-82.5,2.27-97.05-30.65-8.16-18.46,1-39.61,6.06-49.44,0,0,6-14.48,21.52-29.05-6.14,8.88-9.56,18.33-9.84,28.16q0,.66,0,1.32a48.6,48.6,0,0,0,5.33,21.8C653.14,545.32,683.72,565.66,725.35,579Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M805.14,548.82c-.46,3.62-2.55,6.88-5.85,9.82-6.06,5.39-16.22,9.67-28,12.9-14.47,4-31.35,6.42-46,7.44-25.06-8-46.11-18.58-61.47-30.89-10.16-8.13-17.84-17-22.53-26.48a48.6,48.6,0,0,1-5.33-21.8q0-.66,0-1.32c.28-9.83,3.7-19.28,9.84-28.16a105.24,105.24,0,0,1,34.2-21.56h0c.72-.26,2,1.6,2.36,2.19,2.08,3.13,2.27,36.92,9.37,47.91,2.94,4.56,7.65,6.11,13.81,6.47,13.87.82,35.1-4.31,60,5.77C783.41,518.29,807,534.65,805.14,548.82Z",
    style: {
      fill: "#a67c52"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M809.38,563.25a70,70,0,0,1-33.45,8.44c-1.55,0-3.1-.05-4.62-.15,11.76-3.23,21.92-7.51,28-12.9Q804.56,560.85,809.38,563.25Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M850.53,614.09a69,69,0,0,1-6.32,4.4c-1.13.7-2.29,1.38-3.48,2A70,70,0,0,1,806.6,629c15.76-5,28.48-11.26,35-18.61A69.48,69.48,0,0,1,850.53,614.09Z",
    style: {
      fill: "#8c6239"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M252.8,560.07C261,569.58,273,577,283.73,583.39c5.63,3.34,11.43,6.36,17.36,9.13s11.82,5.22,17,9c4.69,3.43,8.59,8,10.2,13.64a15.91,15.91,0,0,1,.27,8.3c-.78,3-2.91,5.36-3.87,8.28a9.11,9.11,0,0,0,4,10.78c4.29,2.75,9.14,2.46,14,2,3.13-.31,6.61-.7,9.32,1.25,2.09,1.51,3.31,3.94,4.3,6.25,2,4.54,3.38,9.25,6.53,13.16a29.39,29.39,0,0,0,3.2,3.38,29.73,29.73,0,0,0,11.14,8.06c1.81.76,3.65,1.41,5.48,2.12,2.06,1,4.11,2.1,6.09,3.24l1.08.65a32.36,32.36,0,0,1,4.85,5.06c1.93,2.44,4.7,5.34,5.18,8.53.53,3.51-1.21,7.16-1.93,10.53a36.61,36.61,0,0,0,.32,15.9A61.58,61.58,0,0,0,406,740.77c-2-.31-4-.48-6-.6q-8.67-4.15-17.58-7.77c-7.31-3-14.72-5.66-22.26-7.94a93.55,93.55,0,0,0-9.23-4.09c-7-2.68-14.21-4.88-21.12-7.82a76.7,76.7,0,0,1-11.3-6.15,41.4,41.4,0,0,0-5.12-3.94,35.84,35.84,0,0,0-4.16-2.27,34.08,34.08,0,0,0-18.8-5.28c-1.58,0-3.09,0-4.56-.11-2.69-.35-5.36-.72-8-1.18a20.62,20.62,0,0,1-8.47-4.94,90.44,90.44,0,0,1-7-7.76c-2.17-2.58-4.85-4.94-6.81-7.68-3.53-4.93-.1-12.27-1.59-18-3.5-13.38-19.5-18.38-30.87-22.64-18.16-6.81-36.22-14-54.86-19.4-2.07-.6-3.22,2.65-1.28,3.57,15.76,7.39,32.16,13.26,48.44,19.4,6.65,2.5,13.51,4.73,19.85,8,4.89,2.52,10.21,6,12.32,11.3,2.25,5.68-.92,11.79,1,17.55.91,2.81,2.91,4.92,4.88,7,2.41,2.57,4.63,5.3,6.92,8-6.48-2.79-12.79-6-19.31-8.86-13.8-5.94-28.6-7.94-43.17-11.12-15.59-3.39-30.85-7.85-46.24-12-3.32-.88-5.4,4.6-2.07,5.8a349.68,349.68,0,0,0,39.6,11.24c13.39,3.12,27.27,4.85,40.39,9,12.5,4,23.67,11.16,36.06,15.41s25.89,3.29,38.11,7.81c11.47,4.25,18.3,15.48,28.14,22.29,9.32,6.46,19.85,10.7,30.56,14.23,4.59,1.51,9.21,2.89,13.84,4.24a273.63,273.63,0,0,1,39.95,18.73c.11.38.23.77.36,1.16a48.24,48.24,0,0,0,3.17,7.62c5.42,10.56,13.78,18.12,23.53,23.77-33.6-6.95-65.82-14.15-104.91-24.06-36.51-9.26-81.72-9.45-111.58-8.17-7.08.3-7.28,8.42-.25,10.13,9.65,2.35,20.54,5,32.4,7.76,22.52,5.32,43.26,10.05,62.64,14.35a47.43,47.43,0,0,1-6.95,4.09,51.81,51.81,0,0,1-21,4.47c-16.43.16-31-9.78-47.46-8.29-7.7.7-15.13,3.08-22.83,3.8s-15.53-.6-23.29,0c-4.4.34-8.38,2-12.69,2.65-4.47.64-9.08-1.73-13.18-3.18-9.59-3.39-19.53-7.71-29.58-9.44a2.15,2.15,0,0,0-1.43,4c7.61,4.35,16.45,7,24.65,10,7,2.58,14.44,6.49,22.06,4.8,2.21-.49,4.32-1.06,6.46-1.52,11.81,2.45,24.13,1,36.1.44a110.85,110.85,0,0,1,21.32.53c7.89,1.16,15.19,4.31,22.92,6.14,14.43,3.43,29.2-.63,43.81.67,7.17.64,13-1.56,19.83-3.26a84.83,84.83,0,0,1,22.25-2c13,.28,26,1.77,39,3.11,77,15.67,136.3,26,220.56,46.18,32.35,7.73,80.87,19.89,140.23,37,6.83,2,13.71-1,15-6.47,2.87-12.45-7.64-25.47-23.42-29C703.71,850.78,662.62,842,634.37,836q-12.4-2.61-24-5c-34-7.07-51.07-10.58-57.37-11.7-39.94-7.07-52.14-6-64.11-15.88a112.79,112.79,0,0,0-15.52-11.32,122.08,122.08,0,0,0-21.16-9.87c-9.17-3.76-20.91-13.16-31.33-38.4a12.17,12.17,0,0,0-.92-2.44,12.6,12.6,0,0,0-1.65-2.46c-3.66-4.28-7.86-7.31-10.05-12.73-2.5-6.19-1.73-12-.57-18.38,1-5.51,1.34-11-1.08-16.2a29.3,29.3,0,0,0-8.81-10.56,49.18,49.18,0,0,0-6.18-4,25.26,25.26,0,0,0-4.54-2.87c-2.37-1.16-4.75-2.08-7-3.08a53.75,53.75,0,0,1-8.52-5.44,20.12,20.12,0,0,1-1.43-1.59c-9-11.33-7.25-26.39-5.73-39.76.33-3,.28-5.52-1.69-7.91-2.28-2.77-5.68-4.84-8.46-7.06-7-5.6-13.85-11.68-21.3-16.67-2.8-1.88-5.6,2.54-3.29,4.72,5.8,5.46,12.44,10.15,18.68,15.1,2.87,2.28,5.85,4.46,8.62,6.85s1.07,6.53.74,9.72a97,97,0,0,0-.59,13.44,13.9,13.9,0,0,0-2.12-1.75c-5.11-3.4-10.92-2-16.63-1.72a11,11,0,0,1-6.26-1.24c-3.32-2-1.7-4.86-.16-7.62,5.36-9.58,2.31-20.64-4.84-28.45-9.21-10.07-23.73-14.08-35.39-20.5a187.22,187.22,0,0,1-18.91-11.92c-5.88-4.25-11.25-9.16-17.2-13.3C253.1,554.27,251.14,558.15,252.8,560.07Z",
    style: {
      fill: "#8c6239"
    }
  }), /*#__PURE__*/React.createElement("g", {
    id: "mouse"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M879.06,259.43c-18.36-5.33-41.58-1.24-58.18,5.88-4.56,2-.56,7,4,5.37a107.62,107.62,0,0,1,27.32-5.95c8.68-.67,18.58-.77,26.56,2.36,7.65,3,12,9.48,7.67,15.73-4.22,6.08-13.19,8.49-21.33,9.85-16.37,2.74-33.45,2.28-49.56,6.09-10.95,2.58-33.11,10.72-22.77,22.23,4.75,5.29,14.25,7.09,21.7,8.78,9.25,2.09,20.18,4.51,29.84,3.48,3.73-.4,2.7-4.33,0-5.15-4.34-1.33-9.17-1.65-13.7-2.5s-9.18-1.68-13.71-2.73c-5.06-1.17-23.51-4.68-14.82-10.89,12.43-8.87,33.6-8.94,49.27-10.39,15.28-1.41,33.95-3.23,42.66-14.62C902.6,275.74,893.51,263.62,879.06,259.43Z",
    style: {
      fill: "#ffb6bd"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 849.39,
    cy: 182.95,
    rx: 13.8,
    ry: 37.06,
    transform: "matrix(0.94, -0.34, 0.34, 0.94, -11.8, 298.22)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 772.36,
    cy: 231.62,
    rx: 95.08,
    ry: 61.7,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 822.83,
    cy: 237.57,
    rx: 37.06,
    ry: 13.8,
    transform: "translate(-24.72 114.48) rotate(-7.84)",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 679.62,
    cy: 224.87,
    r: 62.11,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 620.06,
    cy: 169.92,
    r: 38.34,
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("ellipse", {
    cx: 607.44,
    cy: 263.35,
    rx: 34.52,
    ry: 24.25,
    transform: "translate(-30.25 85.34) rotate(-7.84)",
    style: {
      fill: "#b3b3b3"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M667.1,176c-2.09,4.65-.54,10.83,1,15.44h0c-3.55,1.9-7.89,3.17-10.83,5.94a2.09,2.09,0,0,0,1.33,3.59c3.91.32,8.1-1.73,11.63-3.49,1.33,3.27,3,6.47,5.44,8.47a2.16,2.16,0,0,0,3.69-1.37c.48-3.53-.9-7.35-2.18-10.88a64.64,64.64,0,0,0,6-4.1c3-2.28-.7-7.56-3.8-5.4q-2.07,1.46-4.15,2.86a84.57,84.57,0,0,1-.86-9.91C674.06,172.82,668.82,172.2,667.1,176Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M664.21,249.66c-1.13-5,1.62-10.72,4-14.94h0c-3.1-2.57-7.11-4.67-9.44-8a2.1,2.1,0,0,1,2-3.26c3.88.47,7.58,3.3,10.7,5.74,2-2.95,4.26-5.75,7-7.23a2.16,2.16,0,0,1,3.35,2.08c-.24,3.56-2.34,7-4.3,10.23a67.1,67.1,0,0,1,5,5.21c2.44,2.82-2.19,7.27-4.79,4.53-1.17-1.22-2.33-2.42-3.5-3.62a84.45,84.45,0,0,0-2.82,9.54C670.39,254.16,665.13,253.73,664.21,249.66Z",
    style: {
      fill: "#333"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M795.27,285.78A215.6,215.6,0,0,1,722,270.27c-2.88-1.15-5.53-2.28-7.94-3.35a85.09,85.09,0,0,1-16.23,3c-15.25,1.44-38.47,0-57.83-16.61h0a70.09,70.09,0,0,1-9-9.36,75,75,0,0,1-13.19-24.75c-.17,1.86-.26,3.75-.26,5.66a62.07,62.07,0,0,0,1.78,14.79,46.57,46.57,0,0,0-15.15-.33c-18.88,2.6-32.72,15.46-30.89,28.73s18.62,21.91,37.51,19.3c12.54-1.72,22.86-8,27.83-15.86a62.11,62.11,0,0,0,72.18,7.12c16.59,9.17,38.1,14.7,61.6,14.7a136.56,136.56,0,0,0,46.37-7.82C809.82,285.94,801.74,286,795.27,285.78Z",
    style: {
      fill: "#999"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M642.34,163.21a19.35,19.35,0,0,1,5.48,7.4,65.55,65.55,0,0,0-22.48,26.89,19.67,19.67,0,0,1-4-1.37,19.33,19.33,0,0,1-4.26-2.72,19.68,19.68,0,1,1,25.24-30.2Z",
    style: {
      fill: "#ffb6bd"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M624.5,271a48.73,48.73,0,0,0,8.6-5.05,25.68,25.68,0,0,1-4.4-6.48,25.39,25.39,0,0,1-2.22-7.87c-1.09.25-2.53.63-4.25,1.21a50.79,50.79,0,0,0-5.18,2.07c-11,5.05-18.17,12.77-16.12,17.22S613.54,276,624.5,271Z",
    style: {
      fill: "#ffb6bd"
    }
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgForaging);
export default __webpack_public_path__ + "static/media/foraging.2d0d2d4f6f6b92b7ddd4bd81c778aaa3.svg";
export { ForwardRef as ReactComponent };